<template>
  <div class="current">
    <div class="current_header">
      <div class="current_header_left" @click="$router.push({ path: '/multiomics' })">
        <i class="iconfont iconfanhui"></i>
        <p>返回</p>
      </div>
    </div>
    <div class="main">
      <div class="position">
        <div class="box">
          <p>疾病风险评估中，常见的结论是，终生发病风险XX%、五年内发病风险XX%等。发病风险是一个概率问题，高发病风险的人可能不会得病，低发病风险的人也可能会得病。因此，高风险的人群不需要有不必要的恐慌，低风险人群也不应觉得自己高枕无忧。</p>
          <p>疾病风险的评估可以让人选择更健康的生活方式、对已经出现的风险因素进行管控。但现在我的健康状况如何？我是否需要去看医生？这些是疾病风险评估回答不了的问题。</p>
          <p>在这个模块中，我们提供了部分疾病的筛查量表，帮助您对{{ child === 1 ? '孩子' : '自己' }}的状态进行初步的判断，也为{{ child === 1 ? '孩子' : '您' }}提供了相应的就医建议。</p>
        </div>
        <Btn :btnData="{text: '立即测试'}" @btnClick="$router.push({path: '/currentList'})"></Btn>
      </div>
    </div>
  </div>
</template>

<script>
import Btn from '@/components/Btn'
export default {
  name: 'index',
  components: {
    Btn
  },
  data () {
    return {
      child: this.util.getLS(this.api.child) // 是否是儿童版报告
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/functions";
  .current{

    .current_header {
      width: 100%;
      height: pxToRem(447px);
      background: url("../../assets/images/current/currentList-1.png");
      background-size: cover;
      background-position: center;

      .current_header_left {
        display: flex;
        padding-left: pxToRem(10px);
        width: pxToRem(120px);
        height: pxToRem(88px);
        line-height: pxToRem(88px);
        color: #fff;
      }
    }

    .main {
      width: 100%;
      padding: .15rem;

      .position {
        position: relative;
        z-index: 20;
        width: pxToRem(660px);
        margin: 0 auto;
        margin-top: pxToRem(-80px);

        .box {
          padding: .2rem;
          border-radius: pxToRem(25px);

          p {
            margin-bottom: pxToRem(40px);
            text-align: justify;

            &:last-child {
              margin: 0;
            }
          }
        }

        .info {
          text-align: center;
          font-size: pxToRem(18px);
          color: #929394;
          margin-top: pxToRem(20px);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/current/index.vue